import styles from "./LearnigHistoryScreen.module.css";
import LearningHistory from "./LearningHistory";
import { LearningHistoryRange } from "./learningHistoryRange";
import LearningHistoryCell from "./LearningHistoryCell";

interface LearningHistoryScreenProps {
  items: LearningHistory[];
  onClickItem: (item: LearningHistory) => void;
}

export default function LearningHistoryScreen(
  props: LearningHistoryScreenProps
) {
  function getRange(index: number): LearningHistoryRange {
    if (index === 0) {
      return LearningHistoryRange.day;
    } else if (index === 1) {
      return LearningHistoryRange.week;
    } else {
      return LearningHistoryRange.month;
    }
  }

  return (
    <>
      <div className={styles.screen}>
        {props.items.map((item, index) => (
          <LearningHistoryCell
            key={index}
            learningHistory={item}
            learningHistoryRange={getRange(index)}
            handleOnClick={props.onClickItem}
          />
        ))}
      </div>
    </>
  );
}
